<template>
	<div class="jiedaiOrder">
		<div class="radioBox">
			<el-radio-group v-model="radio" @change="changeRadio">
				<el-radio :label="0">全部</el-radio>
				<el-radio :label="1">待接诊</el-radio>
				<el-radio :label="2">诊疗中</el-radio>
				<el-radio :label="3">诊疗完成</el-radio>
				<!-- <el-radio :label="9">已取消</el-radio> -->
			</el-radio-group>
		</div>
		<el-table :data="tableData" height="100%" style="width: 100%;">
			<el-table-column label="状态" width="70">
				<template slot-scope="scope">
					<span v-if="scope.row.isPay===false">
						<span style="color:red;">待支付</span>
					</span>
					<span v-else>
						<span v-if="scope.row.status===1">待接诊</span>
						<span v-if="scope.row.status===2">已接诊</span>
						<span v-if="scope.row.status===3">已完成</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" width="130">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.createTime,'YYYY-MM-DD HH:mm')}}
				</template>
			</el-table-column>
			<el-table-column label="客户姓名" width="90">
				<template slot-scope="scope">
					{{scope.row.memberName}}
				</template>
			</el-table-column>
			<el-table-column label="宠物" width="90">
				<template slot-scope="scope">
					{{scope.row.petName}}
				</template>
			</el-table-column>
			<el-table-column label="分类" width="50">
				<template slot-scope="scope">
					{{scope.row.categoryName}}
				</template>
			</el-table-column>
			<el-table-column label="医生" width="60">
				<template slot-scope="scope">
					{{scope.row.doctorName}}
				</template>
			</el-table-column>
			<el-table-column label="诊室" width="60">
				<template slot-scope="scope">
					{{scope.row.roomName}}
				</template>
			</el-table-column>
			<el-table-column label="备注">
				<template slot-scope="scope">
					{{scope.row.remark}}
				</template>
			</el-table-column>
			<el-table-column label="销售人员" width="80">
				<!-- <template slot-scope="scope">
					<span v-for="item in scope.row.serviceMan" :key="item">{{item+' '}}</span>
				</template> -->
			</el-table-column>
			<el-table-column label="挂号单号" width="100">
				<template slot-scope="scope">
					{{scope.row.recordId}}
				</template>
			</el-table-column>
			<el-table-column label="金额" width="50">
				<template slot-scope="scope">
					{{scope.row.totalMoney}}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="110">
				<template slot-scope="scope">
					<el-button type="text" @click="see(scope.row)">查看</el-button>
					<el-button v-if="scope.row.isPay===false" @click="pay(scope.row)" type="text" size="small">结算</el-button>
					<el-button v-if="scope.row.isPay===false" @click="del(scope.row)" type="text" size="small">删除记录</el-button>
					<el-button v-if="scope.row.isPay===true" @click="cancel(scope.row)" type="text" size="small">取消订单</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :orderId="curOrder.orderNum" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<guahaoSee v-if="drawerGuahaoSee_state" :curItem="curItem" @submit="submit_drawerGuahaoSee"></guahaoSee>
	</div>
</template>
<script>
	import page from "../../../../../components/page.vue"
	import dialogSettlement from "../../../../../components/dialog_settlement.vue"
	import guahaoSee from "../../drawer/guahaoSee.vue"
	export default {
		components:{page,dialogSettlement,guahaoSee},
		data(){
			return{
				radio:0,
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// see
				drawerGuahaoSee_state:false,
				curItem:{},
				// 结算
				dialogSettlementState: false,
				curOrder: {},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// changeRadio
			changeRadio(){
				this.page.page=1;
				this.getTableData();
			},
			see(row){
				this.drawerGuahaoSee_state = true;
				this.curItem = row;
			},
			submit_drawerGuahaoSee(){
				this.drawerGuahaoSee_state = false;
			},
			// 结算
			pay(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData();
			},
			// 删除挂号记录
			del(row){
				this.$confirm('确定删除这条挂号记录吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"order_id": row.orderNum,
					}
					let loading = this.$loading()
					this.$http.get('/api/Order/ReceivedOrder', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			// 取消订单
			cancel(row){
				this.$confirm('仅取消挂号记录，不涉及到挂号费退款，如要退款，请到订单管理中申请退款操作。确定取消吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						"recordId": row.recordId,
					}
					let loading = this.$loading()
					this.$http.delete('/api/Registration/Delete', params).then(res => {
						loading.close()
						if (res.code == 0) {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.getTableData();
						}
					})
				})
			},
			changePage(num){
				this.page.page=num;
				this.getTableData();
			},
			// 获取列表数据
			getTableData() {
				let curDay = this.$public.FTime(new Date().getTime(),'YYYY-MM-DD')
				let params = {
					"status": this.radio, // 1待接诊；2已接诊；3已完成
					"is_mine": false,
					"memberId": '',
					begin_time: ('' + (new Date(curDay).getTime()-28800000)).substr(0, 10),  //开始时间
					end_time: ('' + (new Date(curDay).getTime()+86400000-28800000)).substr(0, 10),	//结束时间
					"departmentId": 0,
					"isTransfer": 0,
					"keyword": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post('/api/Registration/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.jiedaiOrder{
	width:100%;height: 100%;padding-bottom:50px;box-sizing: border-box;padding-top:40px;position: relative;
	.radioBox{
		padding:12px 30px 12px;position: absolute;z-index: 1;top:0;width:100%;box-sizing: border-box;
	}
	.pageBox{
		// padding:20px;
	}
}
</style>
